import React from 'react';

import './Modal.css';
import Aux from '../../../hoc/Auxi';
import Backdrop from '../Backdrop/Backdrop';

const ModalImage = ( props ) => (
    <Aux>
        <Backdrop show={props.show} clicked={(e)=>props.modalClosed(false)} />
        <div
            className={props.customClassName ? props.customClassName : "Modal"}
            style={{
                transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
                opacity: props.show ? '1' : '0'
            }}>
            {props.children}
        </div>
    </Aux>
);

export default ModalImage;